import { getPblCases } from '@/api/pbl.api';
import type { PblCase } from '@/types/pbl';

// 既有清單在瀏覽器進行搜尋、篩選與分頁，必須先取得 API 的完整分頁資料。
export const loadOcCasePages = async (status?: string): Promise<PblCase[]> => {
  const rows = new Map<number, PblCase>();
  let lastPage = 1;
  for (let page = 1; page <= lastPage; page += 1) {
    const { data } = await getPblCases({ ...(status ? { status } : {}), per_page: 50, page });
    if (data.success !== true) throw new Error(data.message || 'Failed to load cases.');
    if (page === 1) {
      lastPage = data.data.last_page;
      if (!Number.isInteger(lastPage) || lastPage < 1) throw new Error('Invalid case pagination.');
    }
    data.data.data.forEach((item) => {
      if (!status || item.status === status) rows.set(item.id, item);
    });
  }
  return Array.from(rows.values());
};
